import { Dispatch, SetStateAction } from "react";
import { applyCheckPromotionCode } from "src/service/pay";
import { notifyError } from "src/components/Common/Toast";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useTranslation } from "react-i18next";

// Promotion 코드 유무 체크
interface IToggleAskPromotion {
  toggleAskPromotionOn: boolean;
  setToggleAskPromotionOn: Dispatch<SetStateAction<boolean>>;
}
const ToggleAskPromotion = ({
  toggleAskPromotionOn,
  setToggleAskPromotionOn,
}: IToggleAskPromotion) => {
  const { t } = useTranslation();
  // const [product, setProduct] = useState<string>(
  //   getProductFromSessionStorage()
  // );
  const toggleAskPromotion = async () => {
    // 프로모션 신청내역 있으면 불가
    if (!toggleAskPromotionOn) {
      let result = "";
      await applyCheckPromotionCode({ product: getProductFromSessionStorage() })
        .then((res) => {
          // 해당 api 분석 필요
          result = res;
        })
        .catch((error: any) => {
          if (error?.errorCode && error?.errorMessage) {
            notifyError(error.errorMessage);
          }
        });
      if (result) {
        notifyError(t("siteType.premium.detail.plan.alert.Msg1"));
        return;
      }
    }

    setToggleAskPromotionOn((prev) => !prev);
    // setUserName(userInfo.userName)
  };
  return (
    <>
      {toggleAskPromotionOn ? (
        <div className="flex justify-space-between">
          <span className="form-item-title">
            {t("siteType.free.detail.username")}
            <span className="text text--green">&nbsp;*</span>
          </span>

          <span
            className="form-item-question cursor-pointer"
            onClick={toggleAskPromotion}
          >
            {t("siteType.premium.detail.plan.haveCode")}
          </span>
        </div>
      ) : (
        <div className="flex justify-space-between">
          <span
            className="form-item-question cursor-pointer"
            style={{ color: "rgba(49, 130, 246, 1)", marginTop: "30px" }}
            onClick={toggleAskPromotion}
          >
            {t("siteType.premium.detail.plan.dontHaveCode")}
          </span>
          <span className="form-item-title">
            {/* 프로모션 코드 */}
            {/* {t("siteType.premium.detail.plan.promotionCode")} */}
          </span>
        </div>
      )}
    </>
  );
};

export default ToggleAskPromotion;
